<script>
import EzInput from '@/components/ui/Input/EzInput';
import { wizardListenerMixin } from '@/mixins/wizard';
import { mapState, mapMutations } from 'vuex';
import EzForm from '@/components/ui/Form/EzForm';

/**
 *
 * @version 1.0.0
 * @since 2.4.0
 */
export default {
  mixins: [wizardListenerMixin],
  components: {
    EzForm,
    EzInput,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
    distributor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formKey: 'newAccount',
      formValid: false,
      requiredValues: {
        name: null,
        email: null,
      },
      phone: '',
    };
  },
  computed: {
    ...mapState('entities/venues', ['publicOnboarding']),
    venue() {
      return this.publicOnboarding.venue;
    },
    owner() {
      return this.publicOnboarding.owner;
    },
    isEdit() {
      return Object.keys(this.owner).length > 0;
    },
    action() {
      return this.venue
        ? `/public/distributors/${this.distributor.id}/venues/${this.venue.id}/users`
        : `/public/distributors/${this.distributor.id}/venues/users`;
    },
    additionalData() {
      return {
        type: 'owner',
      };
    },
    additionalHeader() {
      return {
        'X-Public-Token': this.token,
      };
    },
    isFormValid() {
      return this.formValid;
    },
  },
  watch: {
    isFormValid(val) {
      if (val) this.enableNextStep();
      else this.disableNextStep();
    },
  },
  methods: {
    onNextStep() {
      this.$refs.userForm.onSubmit();
    },
    async onSubmitSuccess({ data }) {
      await this.UPDATE_PUBLIC_ONBOARDING({
        owner: {
          ...data.data,
        },
        ...(this.venue
          ? {}
          : {
              venue: {
                ...data.data.venue,
              },
            }),
      });
      this.$emit('stepCompleted');
    },
    async updateFormState(name, ev) {
      this.requiredValues[name] = await this.$validator.validate(name, ev);
      this.validateForm();
    },
    validateForm() {
      this.formValid = true;
      Object.keys(this.requiredValues).forEach(key => {
        if (!this.requiredValues[key]) this.formValid = false;
      });
    },
    initialFormState() {
      this.requiredValues = {
        name: this.owner.name,
        email: this.owner.email,
      };
      this.phone = this.owner.phone;
    },
    ...mapMutations('entities/venues', ['UPDATE_PUBLIC_ONBOARDING']),
    ...mapMutations('errors', ['SET_ERROR']),
  },
  mounted() {
    if (this.isEdit) {
      this.initialFormState();
      this.validateForm();
    }
    this.disableFooterActions();
  },
};
</script>
<template>
  <div>
    <ez-form
      class="ordering-fields"
      ref="userForm"
      @success="onSubmitSuccess"
      :additionalHeaders="additionalHeader"
      :formKey="formKey"
      :additionalData="additionalData"
      :action="action"
      method="post"
    >
      <ez-input
        :formKey="formKey"
        name="name"
        :disabled="isEdit"
        :value="owner.name"
        placeholder="Enter Owner Name"
        validators="required"
        @onChange="updateFormState('name', $event)"
        label="Name"
      />
      <ez-input
        class="mt-12"
        :formKey="formKey"
        :value="owner.email"
        :disabled="isEdit"
        label="Email Address"
        @onChange="updateFormState('email', $event)"
        validators="email|required"
        placeholder="Enter Your Email Address"
        name="email"
      />
      <ez-input
        class="mt-12"
        :formKey="formKey"
        :disabled="isEdit"
        :value="owner.phone"
        placeholder="Enter Phone Number"
        name="phone"
        label="Phone Number"
      />
    </ez-form>
  </div>
</template>
<style lang="scss" scoped>
.terms-and-conditions {
  display: flex;
  align-items: center;

  &__checkbox {
    display: inline;
  }

  &__label {
    @include font-size(14px);
    color: $text-color;
    a {
      display: inline-block;
      color: $color-primary-blue;
      text-decoration: none;
    }
  }
}
</style>
